<template>
    <top-bar-right></top-bar-right>
    <navigation :top-bar-categories="topBarCategories" :columns="columns" :active-tab="activeTab"></navigation>
    <donate-now-popup></donate-now-popup>
    <logout-popup></logout-popup>
    <msite-nav :categories="topBarCategories" :columns="columns"></msite-nav>
</template>

<script>
import Navigation from "@/parts/home/TopBar/Navigation.vue";
import SocialMedia from "@/parts/home/SocialMedia.vue";
import Banner from "@/parts/home/TopBar/TopBarRight.vue";
import TopBarRight from "@/parts/home/TopBar/TopBarRight.vue";
import Popup from "@/parts/home/TopBar/SupportPopup.vue";
import SupportPopup from "@/parts/home/TopBar/SupportPopup.vue";
import LogoutPopup from "@/parts/home/TopBar/LogoutPopup.vue";
import MsiteNav from "@/parts/home/TopBar/MsiteNav.vue";
import DonateNowPopup from "@/parts/home/TopBar/DonateNowPopup.vue";

export default {
    name: "TopBar",
    components: {DonateNowPopup, MsiteNav, LogoutPopup, SupportPopup, Popup, TopBarRight, SocialMedia, Navigation},
    props: {
        activeTab: {
            type: String,
            default: 'Home'
        },
        user: {
            type: Object,
            default: null
        },
        topBarCategories: {
            type: Array,
            default: []
        },
        columns: {
            type: Object,
            default: []
        },
        inactiveDonateNowPopup:{
            default: false
        }
    },
    mounted(){
        // if(this.inactiveDonateNowPopup === false){
        //     document.getElementById('donate-now').style.visibility = 'visible'
        // }
    }
}
</script>

<style scoped>

</style>
